interface DropIndicatorProps {
  containerRef: React.RefObject<HTMLDivElement | null>
  dropIndex: number | null
}

export const DropIndicator = ({
  containerRef,
  dropIndex,
}: DropIndicatorProps) => {
  if (dropIndex === null || !containerRef.current) return null

  const container = containerRef.current
  const containerRect = container.getBoundingClientRect()
  const items = container.querySelectorAll('[data-reorder-item]')

  let topOffset: number
  if (dropIndex <= 0) {
    topOffset = 0
  } else if (dropIndex >= items.length) {
    const lastItem = items[items.length - 1]
    if (!lastItem) return null
    const lastRect = lastItem.getBoundingClientRect()
    topOffset = lastRect.bottom - containerRect.top
  } else {
    const itemRect = items[dropIndex].getBoundingClientRect()
    topOffset = itemRect.top - containerRect.top
  }

  return (
    <div
      className="absolute left-3 right-3 z-10 pointer-events-none"
      style={{ top: topOffset - 1 }}
    >
      <div className="h-0.5 rounded-full bg-brand" />
    </div>
  )
}
